import { render } from "./Plans.vue?vue&type=template&id=698550af&scoped=true&ts=true"
import script from "./Plans.vue?vue&type=script&lang=ts"
export * from "./Plans.vue?vue&type=script&lang=ts"

import "./Plans.vue?vue&type=style&index=0&id=698550af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698550af"]])

export default __exports__